import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "./i18n";
import App from "@/App";

// A reload lands at the top, not wherever the browser remembers: the restored
// offset lands mid-page once late images shift the layout. Hash links
// (/#pricing) still scroll themselves, in TrapManLanding.
if ("scrollRestoration" in window.history) window.history.scrollRestoration = "manual";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
